export default __webpack_public_path__ + "static/media/regulatory--no-buses--g3.6b590d19.png";